import { runSilentLogin } from '@krp/client-runtime'

type SilentLogin = () => Promise<boolean>

let current: SilentLogin = () => runSilentLogin()

/** Тихий вход приложения. В тестах jsdom iframe не грузит, поэтому harness подставляет свой. */
export const silentLogin: SilentLogin = () => current()

export function overrideSilentLogin(next: SilentLogin | null): void {
  current = next ?? (() => runSilentLogin())
}
